import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { blockHeaderStyles, blockWrapperStyles } from './SnapdocsClosingBlock.styles';

const SnapdocsClosingBlock = ({
  title,
  dataTestId,
  headerContent = null,
  errorMessage = null,
  emptyMessage = null,
  isEmpty = false,
  children = null,
}) => {
  const getContent = () => {
    if (errorMessage) {
      return (
        <Typography color="error.main" variant="regular14">
          {errorMessage}
        </Typography>
      );
    }

    if (isEmpty) {
      return (
        <Typography color="text.secondary" variant="regular14">
          {emptyMessage}
        </Typography>
      );
    }

    return children;
  };

  return (
    <Box data-testid={dataTestId} sx={blockWrapperStyles}>
      <Box sx={blockHeaderStyles}>
        <Typography variant="medium16">{title}</Typography>
        {headerContent}
      </Box>
      {getContent()}
    </Box>
  );
};

SnapdocsClosingBlock.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  emptyMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  headerContent: PropTypes.node,
  isEmpty: PropTypes.bool,
};

export default memo(SnapdocsClosingBlock);
